var exports = {
  "kL": "RoleColorStyle.module__container___WXZXVn",
  "Pf": "RoleColorStyle.module__label___WXZXVn",
  "U9": "RoleColorStyle.module__pickers___WXZXVn",
  "VH": "RoleColorStyle.module__preview___WXZXVn",
  "gz": "RoleColorStyle.module__previewName___WXZXVn",
  "G7": "RoleColorStyle.module__previewHint___WXZXVn",
};

module.exports = exports;
